var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24784_38202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41782 0.0146342C5.5606 -0.0453453 4.70049 0.079507 3.89571 0.380743C3.09092 0.681979 2.36023 1.15257 1.75307 1.76067C1.14592 2.36877 0.676471 3.1002 0.376491 3.90546C0.0765114 4.71071 -0.0469986 5.57101 0.0143184 6.42813C0.234818 9.60464 3.04082 12.0006 6.54132 12.0006H9.49982C10.1626 11.9998 10.798 11.7362 11.2667 11.2675C11.7354 10.7989 11.999 10.1634 11.9998 9.50064V6.17064C12.0185 4.62936 11.4534 3.13808 10.418 1.99622C9.38259 0.854359 7.95356 0.146453 6.41782 0.0146342ZM5.99982 2.50063C6.19873 2.50063 6.3895 2.57965 6.53015 2.7203C6.6708 2.86096 6.74982 3.05172 6.74982 3.25063C6.74982 3.44955 6.6708 3.64031 6.53015 3.78096C6.3895 3.92162 6.19873 4.00063 5.99982 4.00063C5.80091 4.00063 5.61014 3.92162 5.46949 3.78096C5.32884 3.64031 5.24982 3.44955 5.24982 3.25063C5.24982 3.05172 5.32884 2.86096 5.46949 2.7203C5.61014 2.57965 5.80091 2.50063 5.99982 2.50063ZM6.99982 9.00064C6.99982 9.13324 6.94714 9.26042 6.85337 9.35419C6.7596 9.44796 6.63243 9.50064 6.49982 9.50064C6.36721 9.50064 6.24003 9.44796 6.14627 9.35419C6.0525 9.26042 5.99982 9.13324 5.99982 9.00064V6.00064H5.49982C5.36721 6.00064 5.24003 5.94796 5.14627 5.85419C5.0525 5.76042 4.99982 5.63324 4.99982 5.50063C4.99982 5.36803 5.0525 5.24085 5.14627 5.14708C5.24003 5.05331 5.36721 5.00063 5.49982 5.00063H5.99982C6.26504 5.00063 6.51939 5.10599 6.70693 5.29353C6.89446 5.48106 6.99982 5.73542 6.99982 6.00064V9.00064Z",
    fill: "#68B859"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24784_38202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.afef8adfb9ecd22bd528933a94897a83.svg";
export { ForwardRef as ReactComponent };